export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14780.44783e31.jpg";